<template>
  <v-row
    no-gutters
    class="slider-component"
  >
    <v-col cols="12">
      <h2
        class="f-24 sz-white--text font-weight-medium mb-0 py-3"
        :class="{ 'text-center': $vuetify.display.mdAndUp }"
      >
        {{ title }}
      </h2>
    </v-col>
    <v-col cols="12">
      <v-row no-gutters>
        <v-col cols="12">
          <div class="d-flex">
            <v-sheet
              width="350"
              min-width="350"
              elevation="4"
              rounded
              color="white"
              class="sz-primary-grey--text font-weight-medium mx-3 d-none d-lg-block"
            >
              <v-img
                :src="require('@/assets/images/quotesSlider/1.jpg?as=webp&w=350&h=260')"
                class="rounded"
              />
            </v-sheet>
            <v-slide-group
              ref="sliderRef"
              center-active
              :class="{ 'content-center': contentCenter }"
            >
              <template #default>
                <v-slide-group-item
                  v-for="(n, index) in items"
                  :key="index"
                  v-slot="{ toggle }"
                >
                  <slot
                    :id="index"
                    :item="n"
                    :toggle="toggle"
                  />
                </v-slide-group-item>
              </template>
              <template #prev>
                <v-btn
                  :height="BUTTON_SIZE"
                  :width="BUTTON_SIZE"
                  color="white"
                  icon="$chevronLeft"
                  variant="flat"
                />
              </template>
              <template #next>
                <v-btn
                  :height="BUTTON_SIZE"
                  :width="BUTTON_SIZE"
                  color="white"
                  icon="$chevronRight"
                  variant="flat"
                />
              </template>
            </v-slide-group>
          </div>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import type { QuotesSlider } from '@/types';
import { computed, ref, watch } from 'vue';
import { VSlideGroup } from 'vuetify/lib/components/index.mjs';

type Props = {
  items: QuotesSlider;
  title: string;
  contentCenter: boolean;
};

defineProps<Props>();

const BUTTON_SIZE = 36;

const sliderRef = ref<InstanceType<typeof VSlideGroup> | null>(null);
const isScrolled = computed<boolean>(() => Boolean(sliderRef.value?.scrollOffset && sliderRef.value.scrollOffset > 0));

// Toggle blur
watch(isScrolled, (value) => {
    const sliderComponent = document.querySelector<HTMLDivElement>('.slider-component');
    if (!sliderComponent) return;
    const slideGroupContainer = sliderComponent.querySelector<HTMLDivElement>('.v-slide-group__container');
    if (!slideGroupContainer) return;
    const sliderContent = value ? 'none' : '\'\'';
    slideGroupContainer.style.setProperty('--sliderContent', sliderContent);
});
</script>

<style lang="scss">
// Add blur to vuetify slider
.v-slide-group__container {
  &::after {
    content: var(--sliderContent, '');
    position: absolute;
    top: 0;
    right: 0;
    width: 80px;
    height: 100%;
    background: linear-gradient(to left, rgba(255, 255, 255, 0.1), transparent);
    backdrop-filter: blur(1px);
    -webkit-backdrop-filter: blur(1px);
  }
}
</style>
